import React, { useState, useRef, useEffect } from 'react';
import '../css/LoadingModal.css';
import { useLabels } from '../config/labelsContext';

interface LoadingModalProps {
  message?: string;
  onClose?: () => void | Promise<void>;
  closeLabel?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({
  message: messageProp,
  onClose,
  closeLabel: closeLabelProp,
}) => {
  const { labels } = useLabels();
  const message = messageProp ?? labels.modals.loadingDefaultMessage;
  const closeLabel = closeLabelProp ?? labels.modals.loadingCloseButton;
  // Hide progress counters like "(0/6)" in the modal text.
  const displayMessage =
    message
      ?.toString()
      .replace(/\(\s*[\d,]+\s*\/\s*[\d,]+\s*\)/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim() || message;

  const [closing, setClosing] = useState(false);
  const isMountedRef = useRef(true);
  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    []
  );

  const handleCloseClick = async () => {
    if (!onClose || closing) return;
    setClosing(true);
    try {
      await onClose();
    } finally {
      if (isMountedRef.current) setClosing(false);
    }
  };

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="loading-spinner"></div>
        <p className="loading-message">{displayMessage}</p>
        {onClose && (
          <button
            type="button"
            className={`loading-modal-close-btn${closing ? ' is-loading' : ''}`}
            disabled={closing}
            onClick={handleCloseClick}
          >
            {closing ? <span className="btn-spinner" aria-hidden /> : closeLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default LoadingModal;
